<script lang="ts" setup>
import { HOTMATCH_MB_SWIPER_OPTIONS } from '~/constants'
import { useSwiper } from '~/composables/common/use-swiper'
defineProps({
  isHome: {
    type: Boolean,
    default: false,
  },
})
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean
const { Swiper, SwiperSlide, modules } = useSwiper()
const { fetchHotmatches, hotmatches } = useSports()
fetchHotmatches()

const currentHotmatches = computed(() => {
  if ($isLighthouseBot) {
    return hotmatches.value?.slice(0, 2)
  }
  return hotmatches.value
})
</script>

<template>
  <div v-if="hotmatches?.length" class="hot-match" :class="{ home: isHome }">
    <BaseSection title="Trận hot" icon="icon-hot">
      <Swiper :modules="modules" v-bind="HOTMATCH_MB_SWIPER_OPTIONS">
        <SwiperSlide v-for="item in currentHotmatches" :key="item.match_id">
          <BaseHotmatch :hotmatch="item" custom-class="hotmatch-item-mobile" />
        </SwiperSlide>
      </Swiper>
    </BaseSection>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/mobile/home/hot-match.scss';
</style>
